import styled from "styled-components";

export const ImageContainer = styled.div`
  padding: 10px;

  img {
    width: 96px;
  }

  @media (max-width: 578px) {
    img {
      width: 64px;
    }
  }
`

export const IsNewMark = styled.div.attrs({ children: "New" })`
  position: absolute;
  left: -18px;
  top: 10px;
  width: 75px;
  height: 20px;
  background: #0a2240;
  color: white;
  font-size: 14px;
  line-height: 1;
  text-align: center;
  transform: rotate(-45deg);
  text-transform: uppercase;
  user-select: none;
`
